<template>
    <div class="ah-page project-type-page">
        <div class="page-header bottom-margin">
            <div class="ah-container ">
                <div class="title-row">
                    <div class="title">
                        <h1>專案類型設定</h1>
                    </div>
                    <div class="actions"></div>
                </div>
            </div>
        </div>
        <div class="ah-container">
            <div class="ah-panel">
                <div class="panel-body">
                    <draggable
                        v-if="items.length > 0"
                        v-model="items"
                        draggable=".item"
                        class="project-type-list"
                        handle=".handler"
                        animation="300"
                        @end="onSortDragEnd"
                    >
                        <div v-for="item in items" :key="item.sno" class="item">
                            <div class="handler">
                                <div class="handler-bar"></div>
                                <div class="handler-bar"></div>
                            </div>
                            <div class="name">{{ item.pjcaT_NAM }}</div>
                            <div class="actions">
                                <el-button type="" size="mini" @click="handleItemEdit(item)" icon="el-icon-edit">編輯</el-button>
                                <el-button type="danger" size="mini" @click="handleItemDelete(item)" icon="el-icon-delete"></el-button>
                            </div>
                        </div>
                        <el-button type="primary" @click="handleAddBtnClick" icon="el-icon-plus" style="margin: 20px 0;">新增專案類型</el-button>
                    </draggable>
                    <div style="color: #aaa; text-align: center; line-height: 100px;" v-if="items.length == 0">{{ isLoading ? '載入中...' : '尚無資料' }}</div>
                </div>
            </div>
        </div>
        <EditDialog :visible="editDialog.visible" :typeData="editDialog.typeData" @close="handleEditDialogClose" />
    </div>
</template>
<script type="text/javascript">
import draggable from 'vuedraggable';
import EditDialog from './EditDialog.vue';

export default {
    name: 'project-type',
    components: {
        draggable,
        EditDialog,
    },
    data() {
        return {
            isLoading: true,
            items: [],
            editDialog: {
                visible: false,
                typeData: null,
            },
        };
    },
    mounted() {
        this.updateData();
    },
    methods: {
        async updateData() {
            this.isLoading = true;
            try {
                const resp = await this.$api({
                    url: 'ProjectCategoryManagementPage/GetList',
                    method: 'GET',
                });
                this.items = resp.data.items;
            } catch (error) {
                console.log(error);
            }
            this.isLoading = false;
        },
        handleAddBtnClick() {
            this.editDialog.typeData = null;
            this.editDialog.visible = true;
        },
        handleItemEdit(item) {
            this.editDialog.typeData = item;
            this.editDialog.visible = true;
        },
        handleEditDialogClose(resp) {
            this.editDialog.visible = false;
            this.editDialog.typeData = null;

            if (resp.refresh) {
                this.updateData();
            }
        },
        handleItemDelete(item) {
            this.$confirm(`確定要刪除專案分類：${item.pjcaT_NAM} ?`, {
                confirmButtonText: '確定',
                cancelButtonText: '取消',
            }).then(() => {
                this.$api({
                    url: 'ProjectCategoryManagementPage/Delete',
                    method: 'POST',
                    data: { sno: item.sno },
                }).then(() => {
                    this.updateData();
                });
            });
        },
        async onSortDragEnd() {
            const sortArray = [];
            this.items.forEach((item, index) => {
                sortArray.push({
                    sno: item.sno,
                    sot: index,
                });
            });

            try {
                this.$api({
                    url: 'ProjectCategoryManagementPage/UpdateSort',
                    method: 'POST',
                    data: { items: sortArray },
                });
            } catch (error) {
                console.log(error);
            }
        },
    },
};
</script>
<style lang="scss">
@import "@/assets/scss/vars.scss";

.project-type-page {
    .project-type-list {
        list-style: none;
        padding: 0;
        margin: 0;

        @media (min-width: 768px) {
            padding: 0 50px;
        }

        .item {
            display: flex;
            gap: 10px;
            align-items: center;
            width: 100%;
            padding: 5px;
            background-color: #fff;
            border-bottom: 1px solid #eee;

            .handler {
                display: flex;
                flex-direction: column;
                align-items: center;
                justify-content: center;
                width: 34px;
                height: 30px;
                gap: 3px;
                cursor: move;

                >.handler-bar {
                    position: relative;
                    width: 15px;
                    height: 2px;
                    background-color: #ddd;
                    transition: 0.2s;
                }

                &:hover {
                    >.handler-bar {
                        background-color: #888;
                    }
                }
            }

            .name {
                flex-grow: 1;
                font-size: 11pt;
            }

            .actions {
                width: 200px;
                text-align: right;
            }
        }
    }
}
</style>
